document.addEventListener('DOMContentLoaded', () => {
  const sortByField = document.getElementById('sort-by-field');

  if (sortByField) {
    sortByField.addEventListener('change', () => {
      const currentUrl = new URL(window.location);
      currentUrl.searchParams.set('order_by', sortByField.value);
      currentUrl.pathname = currentUrl.pathname.replace(/\/page\/\d+(\/)?/, '');
      window.location = currentUrl;
    });
  }
});
